import { render } from "./SkeletonHeaderProduct.vue?vue&type=template&id=2013135e&scoped=true"
import script from "./SkeletonHeaderProduct.vue?vue&type=script&lang=js"
export * from "./SkeletonHeaderProduct.vue?vue&type=script&lang=js"

import "./SkeletonHeaderProduct.vue?vue&type=style&index=0&id=2013135e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2013135e"]])

export default __exports__